import DOMPurify from "dompurify";

// Central sanitizer for any HTML we hand to React via dangerouslySetInnerHTML.
// The inputs we render are already app-controlled (static Terms markup, backend
// plan feature strings), but sanitizing is defence-in-depth — if a data source
// ever gets tainted we don't turn it into an XSS vector.
const CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "br", "code", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
    "hr", "i", "li", "ol", "p", "pre", "small", "span", "strong", "sub", "sup",
    "table", "tbody", "td", "th", "thead", "tr", "u", "ul",
  ],
  ALLOWED_ATTR: ["class", "href", "target", "rel", "id"],
  ALLOW_DATA_ATTR: false,
};

// Force safe defaults on any anchor tags so a stray target="_blank" can't
// hand the opener window over to an attacker.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty || "", CONFIG);
}
